module.exports = __webpack_public_path__ + "static/media/letter_r.46153713.m4a";